import { styled } from '@linaria/react';

import { fonts, layout, semantic, space } from '../../theme/tokens';

export const PageWrapper = styled.section`
  width: 100%;
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: ${space[4]} ${space[4]} ${space[8]};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${space[5]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[7]} ${space[7]} ${space[10]};
    gap: ${space[7]};
  }
`;

export const HeadingRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  margin-bottom: ${space[6]};
`;

export const BackButtonSlot = styled.div`
  display: flex;

  @media (min-width: ${layout.desktopBreakpoint}) {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const PageGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[6]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    align-items: flex-start;
    gap: ${space[7]};
  }
`;

export const MainColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${space[6]};
`;

export const SidebarColumn = styled.aside`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: block;
    width: 380px;
    flex-shrink: 0;
    position: sticky;
    top: ${space[5]};
  }
`;

export const MobileSummaryWrapper = styled.div`
  @media (min-width: ${layout.desktopBreakpoint}) {
    display: none;
  }
`;

export const StepBlock = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const StepTitle = styled.h2`
  display: flex;
  align-items: baseline;
  gap: ${space[2]};
  margin: 0;
  font-family: ${fonts.heading};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const StepNumber = styled.span`
  font-family: ${fonts.heading};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const StepHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[3]};
`;

export const ExpressCheckoutBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  margin-top: ${space[2]};
`;

export const ExpressCheckoutLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  text-align: center;
`;

export const ExpressCheckoutDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${space[3]};
  color: ${semantic.text.secondary};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: ${semantic.border.default};
  }
`;

export const SubmitButtonWrapper = styled.div`
  margin-top: ${space[4]};
`;

export const TermsLine = styled.p`
  margin: ${space[3]} 0 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  text-align: center;
`;

export const TermsLink = styled.a`
  color: ${semantic.text.primary};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const SubmittingOverlay = styled.div<{ $active: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${space[7]};
  pointer-events: ${({ $active }) => ($active ? 'none' : 'auto')};
  opacity: ${({ $active }) => ($active ? 0.5 : 1)};
`;
